import type { CustomFlowbiteTheme } from 'flowbite-react';

export const avatarTheme: CustomFlowbiteTheme['avatar'] = {
  root: {
    base: 'flex items-center justify-center space-x-4 rounded',
    bordered: 'p-1 ring-2',
    rounded: 'rounded-full',
    color: {
      dark: 'ring-titan-night-800',
      failure: 'ring-titan-folly-500',
      gray: 'ring-titan-night-500',
      info: 'ring-titan-blue-400',
      light: 'ring-titan-night-300',
      purple: 'ring-titan-folly-500',
      success: 'ring-green-500',
      warning: 'ring-titan-yellow-300',
      pink: 'ring-titan-folly-500',
    },
    img: {
      base: 'rounded',
      off: 'relative overflow-hidden bg-titan-night-100',
      on: '',
      placeholder: 'absolute w-auto h-auto text-titan-night-400 -bottom-1',
    },
    size: {
      xs: 'w-6 h-6',
      sm: 'w-8 h-8',
      md: 'w-10 h-10',
      lg: 'w-20 h-20',
      xl: 'w-36 h-36',
    },
    stacked: 'ring-2 ring-titan-night-50',
    statusPosition: {
      'bottom-left': '-bottom-1 -left-1',
      'bottom-right': '-bottom-1 -right-1',
      'top-left': '-top-1 -left-1',
      'top-right': '-top-1 -right-1',
    },
    status: {
      away: 'bg-titan-yellow-400',
      base: 'absolute h-3.5 w-3.5 rounded-full border-2 border-white',
      busy: 'bg-titan-folly-400',
      offline: 'bg-titan-night-400',
      online: 'bg-green-400',
    },
    initials: {
      text: 'font-medium text-titan-night-600',
      base: 'relative inline-flex items-center justify-center overflow-hidden bg-titan-night-100',
    },
  },
  group: {
    base: 'flex -space-x-4',
  },
  groupCounter: {
    base: 'relative flex h-10 w-10 items-center justify-center rounded-full bg-titan-night-700 text-xs font-medium text-white ring-2 ring-titan-night-300 hover:bg-titan-night-600',
  },
};
